export const COUNTRIES = [
  { value: 'AF', label: 'Afeganistão' },
  { value: 'ZA', label: 'África do Sul' },
  { value: 'AL', label: 'Albânia' },
  { value: 'DE', label: 'Alemanha' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AG', label: 'Antígua e Barbuda' },
  { value: 'SA', label: 'Arábia Saudita' },
  { value: 'DZ', label: 'Argélia' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armênia' },
  { value: 'AU', label: 'Austrália' },
  { value: 'AT', label: 'Áustria' },
  { value: 'AZ', label: 'Azerbaijão' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrein' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BE', label: 'Bélgica' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benim' },
  { value: 'BY', label: 'Bielorrússia' },
  { value: 'BO', label: 'Bolívia' },
  { value: 'BA', label: 'Bósnia e Herzegovina' },
  { value: 'BW', label: 'Botsuana' },
  { value: 'BR', label: 'Brasil' },
  { value: 'BN', label: 'Brunei' },
  { value: 'BG', label: 'Bulgária' },
  { value: 'BF', label: 'Burquina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'BT', label: 'Butão' },
  { value: 'CV', label: 'Cabo Verde' },
  { value: 'CM', label: 'Camarões' },
  { value: 'KH', label: 'Camboja' },
  { value: 'CA', label: 'Canadá' },
  { value: 'QA', label: 'Catar' },
  { value: 'KZ', label: 'Cazaquistão' },
  { value: 'TD', label: 'Chade' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CY', label: 'Chipre' },
  { value: 'CO', label: 'Colômbia' },
  { value: 'KM', label: 'Comores' },
  { value: 'KP', label: 'Coreia do Norte' },
  { value: 'KR', label: 'Coreia do Sul' },
  { value: 'CI', label: 'Costa do Marfim' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'HR', label: 'Croácia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'DK', label: 'Dinamarca' },
  { value: 'DJ', label: 'Djibuti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'EG', label: 'Egito' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'AE', label: 'Emirados Árabes Unidos' },
  { value: 'EC', label: 'Equador' },
  { value: 'ER', label: 'Eritreia' },
  { value: 'SK', label: 'Eslováquia' },
  { value: 'SI', label: 'Eslovênia' },
  { value: 'ES', label: 'Espanha' },
  { value: 'US', label: 'Estados Unidos' },
  { value: 'EE', label: 'Estônia' },
  { value: 'SZ', label: 'Eswatini' },
  { value: 'ET', label: 'Etiópia' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'PH', label: 'Filipinas' },
  { value: 'FI', label: 'Finlândia' },
  { value: 'FR', label: 'França' },
  { value: 'GA', label: 'Gabão' },
  { value: 'GM', label: 'Gâmbia' },
  { value: 'GH', label: 'Gana' },
  { value: 'GE', label: 'Geórgia' },
  { value: 'GD', label: 'Granada' },
  { value: 'GR', label: 'Grécia' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GY', label: 'Guiana' },
  { value: 'GN', label: 'Guiné' },
  { value: 'GQ', label: 'Guiné Equatorial' },
  { value: 'GW', label: 'Guiné-Bissau' },
  { value: 'HT', label: 'Haiti' },
  { value: 'NL', label: 'Holanda' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HU', label: 'Hungria' },
  { value: 'YE', label: 'Iêmen' },
  { value: 'MH', label: 'Ilhas Marshall' },
  { value: 'SB', label: 'Ilhas Salomão' },
  { value: 'IN', label: 'Índia' },
  { value: 'ID', label: 'Indonésia' },
  { value: 'IR', label: 'Irã' },
  { value: 'IQ', label: 'Iraque' },
  { value: 'IE', label: 'Irlanda' },
  { value: 'IS', label: 'Islândia' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Itália' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japão' },
  { value: 'JO', label: 'Jordânia' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'LA', label: 'Laos' },
  { value: 'LS', label: 'Lesoto' },
  { value: 'LV', label: 'Letônia' },
  { value: 'LB', label: 'Líbano' },
  { value: 'LR', label: 'Libéria' },
  { value: 'LY', label: 'Líbia' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lituânia' },
  { value: 'LU', label: 'Luxemburgo' },
  { value: 'MK', label: 'Macedônia do Norte' },
  { value: 'MG', label: 'Madagáscar' },
  { value: 'MY', label: 'Malásia' },
  { value: 'MW', label: 'Malauí' },
  { value: 'MV', label: 'Maldivas' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MA', label: 'Marrocos' },
  { value: 'MU', label: 'Maurício' },
  { value: 'MR', label: 'Mauritânia' },
  { value: 'MX', label: 'México' },
  { value: 'MM', label: 'Mianmar' },
  { value: 'FM', label: 'Micronésia' },
  { value: 'MZ', label: 'Moçambique' },
  { value: 'MD', label: 'Moldávia' },
  { value: 'MC', label: 'Mônaco' },
  { value: 'MN', label: 'Mongólia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'NA', label: 'Namíbia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NI', label: 'Nicarágua' },
  { value: 'NE', label: 'Níger' },
  { value: 'NG', label: 'Nigéria' },
  { value: 'NO', label: 'Noruega' },
  { value: 'NZ', label: 'Nova Zelândia' },
  { value: 'OM', label: 'Omã' },
  { value: 'PW', label: 'Palau' },
  { value: 'PA', label: 'Panamá' },
  { value: 'PG', label: 'Papua-Nova Guiné' },
  { value: 'PK', label: 'Paquistão' },
  { value: 'PY', label: 'Paraguai' },
  { value: 'PE', label: 'Peru' },
  { value: 'PL', label: 'Polônia' },
  { value: 'PT', label: 'Portugal' },
  { value: 'KE', label: 'Quênia' },
  { value: 'KG', label: 'Quirguistão' },
  { value: 'GB', label: 'Reino Unido' },
  { value: 'CF', label: 'República Centro-Africana' },
  { value: 'CD', label: 'República Democrática do Congo' },
  { value: 'CG', label: 'República do Congo' },
  { value: 'DO', label: 'República Dominicana' },
  { value: 'CZ', label: 'República Tcheca' },
  { value: 'RO', label: 'Romênia' },
  { value: 'RW', label: 'Ruanda' },
  { value: 'RU', label: 'Rússia' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'LC', label: 'Santa Lúcia' },
  { value: 'KN', label: 'São Cristóvão e Névis' },
  { value: 'ST', label: 'São Tomé e Príncipe' },
  { value: 'VC', label: 'São Vicente e Granadinas' },
  { value: 'SN', label: 'Senegal' },
  { value: 'SL', label: 'Serra Leoa' },
  { value: 'RS', label: 'Sérvia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SG', label: 'Singapura' },
  { value: 'SY', label: 'Síria' },
  { value: 'SO', label: 'Somália' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudão' },
  { value: 'SS', label: 'Sudão do Sul' },
  { value: 'SE', label: 'Suécia' },
  { value: 'CH', label: 'Suíça' },
  { value: 'SR', label: 'Suriname' },
  { value: 'TH', label: 'Tailândia' },
  { value: 'TJ', label: 'Tajiquistão' },
  { value: 'TZ', label: 'Tanzânia' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad e Tobago' },
  { value: 'TN', label: 'Tunísia' },
  { value: 'TM', label: 'Turcomenistão' },
  { value: 'TR', label: 'Turquia' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UA', label: 'Ucrânia' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UY', label: 'Uruguai' },
  { value: 'UZ', label: 'Uzbequistão' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VA', label: 'Vaticano' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Vietnã' },
  { value: 'ZM', label: 'Zâmbia' },
  { value: 'ZW', label: 'Zimbábue' },
];

export const NATIONALITIES = [
  { value: 'AF', label: 'Afegã' },
  { value: 'ZA', label: 'Sul-Africana' },
  { value: 'AL', label: 'Albanesa' },
  { value: 'DE', label: 'Alemã' },
  { value: 'AD', label: 'Andorrana' },
  { value: 'AO', label: 'Angolana' },
  { value: 'AG', label: 'Antiguano-Barbudense' },
  { value: 'SA', label: 'Saudita' },
  { value: 'DZ', label: 'Argelina' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armênia' },
  { value: 'AU', label: 'Australiana' },
  { value: 'AT', label: 'Austríaca' },
  { value: 'AZ', label: 'Azerbaijana' },
  { value: 'BS', label: 'Bahamense' },
  { value: 'BH', label: 'Barenita' },
  { value: 'BD', label: 'Bangladeshiana' },
  { value: 'BB', label: 'Barbadiana' },
  { value: 'BE', label: 'Belga' },
  { value: 'BZ', label: 'Belizenha' },
  { value: 'BJ', label: 'Beninense' },
  { value: 'BY', label: 'Bielorrussa' },
  { value: 'BO', label: 'Boliviana' },
  { value: 'BA', label: 'Bósnia' },
  { value: 'BW', label: 'Botsuanesa' },
  { value: 'BR', label: 'Brasileira' },
  { value: 'BN', label: 'Bruneíana' },
  { value: 'BG', label: 'Búlgara' },
  { value: 'BF', label: 'Burquinabê' },
  { value: 'BI', label: 'Burundesa' },
  { value: 'BT', label: 'Butanesa' },
  { value: 'CV', label: 'Cabo-Verdiana' },
  { value: 'CM', label: 'Camaronesa' },
  { value: 'KH', label: 'Cambojana' },
  { value: 'CA', label: 'Canadense' },
  { value: 'QA', label: 'Catarense' },
  { value: 'KZ', label: 'Cazaque' },
  { value: 'TD', label: 'Chadiana' },
  { value: 'CL', label: 'Chilena' },
  { value: 'CN', label: 'Chinesa' },
  { value: 'CY', label: 'Cipriota' },
  { value: 'CO', label: 'Colombiana' },
  { value: 'KM', label: 'Comorense' },
  { value: 'KP', label: 'Norte-Coreana' },
  { value: 'KR', label: 'Sul-Coreana' },
  { value: 'CI', label: 'Marfinense' },
  { value: 'CR', label: 'Costarriquenha' },
  { value: 'HR', label: 'Croata' },
  { value: 'CU', label: 'Cubana' },
  { value: 'DK', label: 'Dinamarquesa' },
  { value: 'DJ', label: 'Djibutiana' },
  { value: 'DM', label: 'Dominiquense' },
  { value: 'EG', label: 'Egípcia' },
  { value: 'SV', label: 'Salvadorenha' },
  { value: 'AE', label: 'Emiradense' },
  { value: 'EC', label: 'Equatoriana' },
  { value: 'ER', label: 'Eritreia' },
  { value: 'SK', label: 'Eslovaca' },
  { value: 'SI', label: 'Eslovena' },
  { value: 'ES', label: 'Espanhola' },
  { value: 'US', label: 'Estadunidense' },
  { value: 'EE', label: 'Estoniana' },
  { value: 'SZ', label: 'Essuatiniana' },
  { value: 'ET', label: 'Etíope' },
  { value: 'FJ', label: 'Fijiana' },
  { value: 'PH', label: 'Filipina' },
  { value: 'FI', label: 'Finlandesa' },
  { value: 'FR', label: 'Francesa' },
  { value: 'GA', label: 'Gabonesa' },
  { value: 'GM', label: 'Gambiana' },
  { value: 'GH', label: 'Ganesa' },
  { value: 'GE', label: 'Georgiana' },
  { value: 'GD', label: 'Granadina' },
  { value: 'GR', label: 'Grega' },
  { value: 'GT', label: 'Guatemalteca' },
  { value: 'GY', label: 'Guianense' },
  { value: 'GN', label: 'Guineana' },
  { value: 'GQ', label: 'Guinéu-Equatoriana' },
  { value: 'GW', label: 'Guineense' },
  { value: 'HT', label: 'Haitiana' },
  { value: 'NL', label: 'Holandesa' },
  { value: 'HN', label: 'Hondurenha' },
  { value: 'HU', label: 'Húngara' },
  { value: 'YE', label: 'Iemenita' },
  { value: 'MH', label: 'Marshallina' },
  { value: 'SB', label: 'Salomônica' },
  { value: 'IN', label: 'Indiana' },
  { value: 'ID', label: 'Indonésia' },
  { value: 'IR', label: 'Iraniana' },
  { value: 'IQ', label: 'Iraquiana' },
  { value: 'IE', label: 'Irlandesa' },
  { value: 'IS', label: 'Islandesa' },
  { value: 'IL', label: 'Israelense' },
  { value: 'IT', label: 'Italiana' },
  { value: 'JM', label: 'Jamaicana' },
  { value: 'JP', label: 'Japonesa' },
  { value: 'JO', label: 'Jordaniana' },
  { value: 'KI', label: 'Kiribatiana' },
  { value: 'KW', label: 'Kuwaitiana' },
  { value: 'LA', label: 'Laosiana' },
  { value: 'LS', label: 'Lesotiana' },
  { value: 'LV', label: 'Letã' },
  { value: 'LB', label: 'Libanesa' },
  { value: 'LR', label: 'Liberiana' },
  { value: 'LY', label: 'Líbia' },
  { value: 'LI', label: 'Liechtensteiniana' },
  { value: 'LT', label: 'Lituana' },
  { value: 'LU', label: 'Luxemburguesa' },
  { value: 'MK', label: 'Macedônia' },
  { value: 'MG', label: 'Malgaxe' },
  { value: 'MY', label: 'Malaia' },
  { value: 'MW', label: 'Malauiana' },
  { value: 'MV', label: 'Maldiva' },
  { value: 'ML', label: 'Maliana' },
  { value: 'MT', label: 'Maltesa' },
  { value: 'MA', label: 'Marroquina' },
  { value: 'MU', label: 'Mauriciana' },
  { value: 'MR', label: 'Mauritana' },
  { value: 'MX', label: 'Mexicana' },
  { value: 'MM', label: 'Birmanesa' },
  { value: 'FM', label: 'Micronésia' },
  { value: 'MZ', label: 'Moçambicana' },
  { value: 'MD', label: 'Moldávia' },
  { value: 'MC', label: 'Monegasca' },
  { value: 'MN', label: 'Mongol' },
  { value: 'ME', label: 'Montenegrina' },
  { value: 'NA', label: 'Namibiana' },
  { value: 'NR', label: 'Nauruana' },
  { value: 'NP', label: 'Nepalesa' },
  { value: 'NI', label: 'Nicaraguense' },
  { value: 'NE', label: 'Nigerina' },
  { value: 'NG', label: 'Nigeriana' },
  { value: 'NO', label: 'Norueguesa' },
  { value: 'NZ', label: 'Neozelandesa' },
  { value: 'OM', label: 'Omanense' },
  { value: 'PW', label: 'Palauense' },
  { value: 'PA', label: 'Panamenha' },
  { value: 'PG', label: 'Papua-Nova-Guineense' },
  { value: 'PK', label: 'Paquistanesa' },
  { value: 'PY', label: 'Paraguaia' },
  { value: 'PE', label: 'Peruana' },
  { value: 'PL', label: 'Polonesa' },
  { value: 'PT', label: 'Portuguesa' },
  { value: 'KE', label: 'Queniana' },
  { value: 'KG', label: 'Quirguiz' },
  { value: 'GB', label: 'Britânica' },
  { value: 'CF', label: 'Centro-Africana' },
  { value: 'CD', label: 'Congolesa' },
  { value: 'CG', label: 'Congolesa' },
  { value: 'DO', label: 'Dominicana' },
  { value: 'CZ', label: 'Tcheca' },
  { value: 'RO', label: 'Romena' },
  { value: 'RW', label: 'Ruandesa' },
  { value: 'RU', label: 'Russa' },
  { value: 'WS', label: 'Samoana' },
  { value: 'SM', label: 'São-Marinense' },
  { value: 'LC', label: 'Santa-Lucense' },
  { value: 'KN', label: 'São-Cristovense' },
  { value: 'ST', label: 'São-Tomense' },
  { value: 'VC', label: 'São-Vicentina' },
  { value: 'SN', label: 'Senegalesa' },
  { value: 'SL', label: 'Serra-Leonesa' },
  { value: 'RS', label: 'Sérvia' },
  { value: 'SC', label: 'Seychellense' },
  { value: 'SG', label: 'Singapuriana' },
  { value: 'SY', label: 'Síria' },
  { value: 'SO', label: 'Somali' },
  { value: 'LK', label: 'Cingalesa' },
  { value: 'SD', label: 'Sudanesa' },
  { value: 'SS', label: 'Sul-Sudanesa' },
  { value: 'SE', label: 'Sueca' },
  { value: 'CH', label: 'Suíça' },
  { value: 'SR', label: 'Surinamesa' },
  { value: 'TH', label: 'Tailandesa' },
  { value: 'TJ', label: 'Tajique' },
  { value: 'TZ', label: 'Tanzaniana' },
  { value: 'TL', label: 'Timorense' },
  { value: 'TG', label: 'Togolesa' },
  { value: 'TO', label: 'Tonganesa' },
  { value: 'TT', label: 'Trinitária' },
  { value: 'TN', label: 'Tunisiana' },
  { value: 'TM', label: 'Turcomana' },
  { value: 'TR', label: 'Turca' },
  { value: 'TV', label: 'Tuvaluana' },
  { value: 'UA', label: 'Ucraniana' },
  { value: 'UG', label: 'Ugandesa' },
  { value: 'UY', label: 'Uruguaia' },
  { value: 'UZ', label: 'Uzbeque' },
  { value: 'VU', label: 'Vanuatuense' },
  { value: 'VA', label: 'Vaticana' },
  { value: 'VE', label: 'Venezuelana' },
  { value: 'VN', label: 'Vietnamita' },
  { value: 'ZM', label: 'Zambiana' },
  { value: 'ZW', label: 'Zimbabuense' },
];
